import ItemReport from "../Components/ItemDetailReport";
import StockReport from "../Components/StockReport";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ProductWiseSales from "../Components/ProductWiseSales";
import AllInvoiceReport from "../Components/AllInvoiceReport";
import AllSalesReport from "../Components/AllSalesReport";
import SalesAnalyticsReport from "../Components/SalesAnalyticsReport";
import KitchenInventoryReport from "../Components/KitchenInventoryReport";
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import KitchenOutlinedIcon from '@mui/icons-material/KitchenOutlined';

export const ReportModules = [
    {
        id: 1,
        name: 'All Sales Report',
        component: AllSalesReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 6,
        name: 'Sales Analytics',
        component: SalesAnalyticsReport,
        icon: <ShowChartOutlinedIcon />
    },
    {
        id: 2,
        name: 'Sales Report',
        component: ItemReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 3,
        name: 'All Invoices Report',
        component: AllInvoiceReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 4,
        name: 'Inventory Report',
        component: StockReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 5,
        name: 'Product Wise Sales Report',
        component: ProductWiseSales,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 7,
        name: 'Kitchen Inventory Report',
        component: KitchenInventoryReport,
        icon: <KitchenOutlinedIcon />
    }
];
